import { render, staticRenderFns } from "./Cardiologia.vue?vue&type=template&id=f10e3410"
import script from "./Cardiologia.vue?vue&type=script&lang=js"
export * from "./Cardiologia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports